<template>
  <div class="disclaimer">
    <div class="text">{{$t('inventory_staging.disclaimer')}} "{{versionName}}"</div>
    <button class="btn" @click="showDiffs">{{$t('inventory_staging.show_diffs')}}</button>

    <Modal name="staging-diffs" :width="650" :actions="[{name: $t('back'), action: 'close'}]" >
      <DiffSet :diffs="diffs"/>
    </Modal>
  </div>
</template>

<script>

import {Core} from "@/core/Core";
import DiffSet from "@/components/inventory/DiffSet";

export default {
  name: "StagingDisclaimer",
  components: {DiffSet},

  props: {
    viewRef: Object /* vueRef */
  },

  data() {
    return {
      diffs: [],
    }
  },

  computed: {
    versionName() {
      return this.viewRef.version ? this.viewRef.version.name : null
    }
  },

  methods: {
    async showDiffs() {
      let dto = null;
      let entity = null;
      let ref = this.viewRef;
      let routeName = ref.$route.name;

      if (typeof ref.getSerializedData === 'function') {
        dto = ref.getSerializedData();
        entity = {
          type: routeName.toLowerCase().includes('category') ? 'category' : 'item',
          id: dto.id
        };
      } else {
        console.log(`viewName '${routeName}' not mapped to showDiff`);
        toast(this.$t("error.no_server"), "error");
        return;
      }

      /* Unsupported fields */
      delete dto.image;

      let response = await Core.noThrowRequest('POST', '/api/inventory_stagings_compute_entity_diffs', {dto, entity});
      if (response) {
        this.diffs = response.diffs;
        this.$modal.show("staging-diffs");
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.disclaimer {
  display: flex;
  justify-content: center;
  background-color: yellow;
  width: 100%;
  line-height: 2em;

  button {
    margin-left: 10px;
    background-color: yellow;
    border: black 1px solid;
    color: black;
  }
}
</style>